import { apiSlice } from "./apiSlice"
import {deepmerge} from "../helpers/utils";

const extendedApi = apiSlice.injectEndpoints({
	endpoints: (build) => ({
		
		updateMe: build.mutation({
			query: patch => ({
				url: '/settings',
				method: 'POST',
				body: patch.data
			}),
		}),
		
		deleteEmailChangeRequest: build.mutation({
			query: () => ({
				url: '/settings/email/change/cancel',
				method: 'POST',
				body: {
					change_email_request: null
				}
			}),
			async onQueryStarted(patch, { dispatch, queryFulfilled }) {
				const patchResult = dispatch(
					apiSlice.util.updateQueryData('getMe', undefined, draft => {
						Object.assign(draft, deepmerge(draft, patch))
					})
				)
				try {
					await queryFulfilled
				} catch {
					patchResult.undo()
				}
			}
		}),
		
		resendEmailChangeRequest: build.mutation({
			query: () => ({
				url: '/settings/email/change/resend',
				method: 'POST'
			}),
		}),
		
		updateNotifications: build.mutation({
			query: (data) => ({
				url: '/settings/notifications',
				method: 'POST',
				body: data.data
			})
		}),
		
		updatePassword: build.mutation({
			query: (data) => ({
				url: '/settings/password',
				method: 'POST',
				body: data.data
			})
		})
	}),
	overrideExisting: false,
})

export const {
	useUpdateMeMutation,
	useUpdateNotificationsMutation,
	useResendEmailChangeRequestMutation,
	useDeleteEmailChangeRequestMutation,
	useUpdatePasswordMutation
} = extendedApi
